import { useEffect, useRef } from "react";

/**
 * Hook that prevents keyboard input until a key is released.
 */
export const useWaitForKeyRelease = (
  enabled: boolean,
  { keysAlreadyReleased = false }: { keysAlreadyReleased?: boolean } = {}
) => {
  const keyboardActiveRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      keyboardActiveRef.current = false;
    } else if (keysAlreadyReleased) {
      keyboardActiveRef.current = true;
    } else {
      // Wait for the key that opened the modal to be released
      keyboardActiveRef.current = false;

      const handleKeyUp = () => {
        keyboardActiveRef.current = true;
        window.removeEventListener("keyup", handleKeyUp);
      };

      window.addEventListener("keyup", handleKeyUp);
      return () => {
        window.removeEventListener("keyup", handleKeyUp);
      };
    }
  }, [enabled, keysAlreadyReleased]);

  return keyboardActiveRef;
};
